import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

export const ListQuestionBankSlice = createSlice({
  name: "ListQuestionBankSlice",
  initialState: {} as IReduxState<[]>,
  reducers: {
    listQuestionBank: (state) => {
      state.isLoading = true;
    },
    successlistQuestionBank: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistQuestionBank: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  failurelistQuestionBank,
  listQuestionBank,
  successlistQuestionBank,
} = ListQuestionBankSlice.actions;

export default ListQuestionBankSlice.reducer;
